__turbopack_context__.v({
  "bulletSeparator": "BulletSeparator-module-scss-module__2ls6Lq__bulletSeparator",
});
